import { useState } from "react";

export default function Upload({ points, setPoints, setPage }) {
  const [image, setImage] = useState(null);

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (file) setImage(URL.createObjectURL(file));
  };

  const handleSubmit = () => {
    setPoints(points + 10);
    alert("ส่งรูปสำเร็จ! +10 แต้ม");
    setImage(null);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-start bg-gradient-to-b from-blue-400 via-red-400 to-red-600 p-6">
      <h1 className="text-3xl font-bold text-white mt-6 mb-8 text-center">
        อัพโหลดรูปเพื่อรับแต้ม
      </h1>

      <div className="bg-white shadow-lg p-6 rounded-3xl w-full max-w-md">
        <input
          type="file"
          accept="image/*"
          capture="environment"
          onChange={handleUpload}
          className="mb-4 w-full"
        />

        {image && (
          <img
            src={image}
            alt="preview"
            className="w-full h-64 object-cover rounded-2xl mb-4"
          />
        )}

        <button
          onClick={handleSubmit}
          disabled={!image}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-2xl font-semibold disabled:bg-gray-400 transition mb-4"
        >
          ส่งรูป
        </button>

        <button
          onClick={() => setPage("dashboard")}
          className="w-full bg-red-500 hover:bg-red-600 text-white py-3 rounded-2xl font-semibold transition"
        >
          ไปหน้า Dashboard
        </button>
      </div>
    </div>
  );
}
